import { environment } from '../../environments/environment';
import { DocumentReference, NameValue } from '.';

export class ActivityFormat {

    constructor() {
        this.displayName = '';
        
        this.activity = null;
        this.category = null;
        this.serviceYear = environment.serviceYear;

        this.hasFee = false;
        this.liveFeeValue = null;
        this.onlineFeeValue = null;
        this.feeDueDate = null;

        this.hasFileUpload = false;
        this.fileUploadLabel = '';
        this.uploadDueDate = null;

        this.hasLink = false;
        this.linkLabel = '';

        this.hasMaxMembersLimit = false;
        this.maxMembers = 1;

        this.hasMinMembersLimit = false;
        this.minMembers = 1;

        this.hasMaxTeamsLimit = false;
        this.maxTeams = 1;

        this.yearLevelList = [];
        
        this.isActive = true;
        this.isDeleted = false;
        
        this.creationStartDate = new Date();
        this.creationDueDate = new Date();   
        
        this.hasApproval = false;
        this.approvalDueDate = null;

        this.hasCommitteeReview = false;
        this.committeeReviewDueDate = null;
        
        this.resubmissionDueDate = null;
    }

    id?: string;
    displayName: string;
    
    serviceYear: string;
    activity: NameValue;
    category?: NameValue;
    
    hasFee: boolean;
    liveFeeValue?: number;
    onlineFeeValue?: number;
    feeDueDate?: Date | string;

    hasFileUpload: boolean;
    fileUploadLabel: string; 
    uploadDueDate: Date | string;

    hasLink: boolean;
    linkLabel: string;
    linkDueDate: Date | string;

    areMembersRequiredOnCreation: boolean;
    membersDueDate: Date | string;

    hasMaxMembersLimit: boolean;
    maxMembers?: number;

    hasMinMembersLimit: boolean;
    minMembers?: number;

    hasMaxTeamsLimit: boolean;
    maxTeams?: number;

    yearLevelList: DocumentReference[];

    isActive: boolean;
    isDeleted: boolean;

    creationStartDate: Date | string;
    creationDueDate: Date | string;
    
    hasApproval: boolean;
    approvalDueDate?: Date | string;

    hasCommitteeReview: boolean;
    committeeReviewDueDate?: Date | string;

    resubmissionDueDate?: Date | string;

    hasSocialMediaConsent: boolean;
    consentMessage: string;

    hasPerformanceExtraRoles: boolean
    performanceRolesDueDate: Date | string;
}
